<ng-container *ngIf="employeeRecord">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ employeeRecord.lastName }}, {{ employeeRecord.firstName }}</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="true"
				[hideCancel]=""
				[hideDelete]="userService.userSubscription.value.role <= 4"
				[hideSave]="userService.userSubscription.value.role <= 4"
				(onCancelChange)="back()"
				(onDeleteChange)="delete()"
				(onSaveChange)="save()"
				[cancelDisabled]=""
				[deleteDisabled]="userService.userSubscription.value.role <= 4"
				[saveDisabled]="userService.userSubscription.value.role <= 4"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="card display-14"></div>
</ng-container>
